'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../core/view');

var _view2 = _interopRequireDefault(_view);

var _screen = require('./screen.scss');

var _screen2 = _interopRequireDefault(_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SECONDS_COUNT = 5;

var ScreenView = function (_View) {
  _inherits(ScreenView, _View);

  function ScreenView(config) {
    _classCallCheck(this, ScreenView);

    var _this = _possibleConstructorReturn(this, (ScreenView.__proto__ || Object.getPrototypeOf(ScreenView)).call(this, config));

    var callbacks = config.callbacks,
        nativeControls = config.nativeControls,
        indicateScreenClick = config.indicateScreenClick;


    _this._nativeControls = nativeControls;
    _this._indicateScreenClick = indicateScreenClick;

    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['screen-block'],
      'data-hook': 'screen-block',
      tabIndex: 0
    });

    if (_this._indicateScreenClick) {
      _this.$iconContainer = (0, _jbone2.default)('<div>', {
        class: '' + _this.styleNames['icon-container']
      });

      _this.$node.append(_this.$iconContainer);
    }

    _this.playIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['play-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14"><path fill="#FFF" fill-rule="evenodd" d="M.079 0L0 14l10.5-7.181z"/></svg></div>';
    _this.pauseIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['pause-icon'] + ' ' + _this.styleNames['animated-icon'] + '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"><path fill="#FFF" fill-rule="evenodd" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/></svg></div>';
    _this.forwardIcon = '<div class="' + _this.styleNames.icon + '"><div class="' + _this.styleNames.seconds + '"><span>' + SECONDS_COUNT + '</span></div><svg class="' + _this.styleNames['forward-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path fill="#FFF" fill-rule="evenodd" d="M17 0c4.59 0 8.84 1.87 11.9 4.93V1.7h3.4v10.2H22.1V8.5h5.44C24.99 5.27 21.25 3.4 17 3.4 9.52 3.4 3.4 9.52 3.4 17c0 7.48 6.12 13.6 13.6 13.6 7.48 0 13.6-6.12 13.6-13.6H34c0 9.35-7.65 17-17 17S0 26.35 0 17 7.65 0 17 0z"/></svg></div>';
    _this.rewindIcon = '<div class="' + _this.styleNames.icon + '"><div class="' + _this.styleNames.seconds + '"><span>' + SECONDS_COUNT + '</span></div><svg class="' + _this.styleNames['rewind-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path fill="#FFF" fill-rule="evenodd" d="M17 0C12.41 0 8.16 1.87 5.1 4.93V1.7H1.7v10.2h10.2V8.5H6.46C9.01 5.27 12.75 3.4 17 3.4c7.48 0 13.6 6.12 13.6 13.6 0 7.48-6.12 13.6-13.6 13.6-7.48 0-13.6-6.12-13.6-13.6H0c0 9.35 7.65 17 17 17s17-7.65 17-17S26.35 0 17 0z"/></svg></div>';
    _this.descreaseVolumeIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['decrease-volume-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/><path stroke="#FFF" d="M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/></g></svg></div>';
    _this.increaseVolumeIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['increase-volume-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/><path stroke="#FFF" d="M12.793 13.716a9.607 9.607 0 0 0 0-13.586M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/></g></svg></div>';

    _this._bindEvents();
    return _this;
  }

  _createClass(ScreenView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$node[0].addEventListener('click', this._callbacks.onWrapperMouseClick);
      this.$node[0].addEventListener('keydown', this._callbacks.onWrapperKeyPress);
    }
  }, {
    key: 'focusOnNode',
    value: function focusOnNode() {
      this.$node[0].focus();
    }
  }, {
    key: 'activatePlayIcon',
    value: function activatePlayIcon() {
      this.$iconContainer.html(this.playIcon);
    }
  }, {
    key: 'activatePauseIcon',
    value: function activatePauseIcon() {
      this.$iconContainer.html(this.pauseIcon);
    }
  }, {
    key: 'activateForwardIcon',
    value: function activateForwardIcon() {
      this.$iconContainer.html(this.forwardIcon);
    }
  }, {
    key: 'activateRewindIcon',
    value: function activateRewindIcon() {
      this.$iconContainer.html(this.rewindIcon);
    }
  }, {
    key: 'activateIncreaseVolumeIcon',
    value: function activateIncreaseVolumeIcon() {
      this.$iconContainer.html(this.increaseVolumeIcon);
    }
  }, {
    key: 'activateDecreaseVolumeIcon',
    value: function activateDecreaseVolumeIcon() {
      this.$iconContainer.html(this.descreaseVolumeIcon);
    }
  }, {
    key: 'deactivateIcon',
    value: function deactivateIcon() {
      this.$iconContainer.html('');
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'appendPlaybackViewNode',
    value: function appendPlaybackViewNode(node) {
      this.$node.append(node);
      if (this._nativeControls) {
        node.setAttribute('controls', 'true');
      }
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('click', this._callbacks.onWrapperMouseClick);
      this.$node[0].removeEventListener('keypress', this._callbacks.onWrapperKeyPress);
    }
  }, {
    key: 'appendComponentNode',
    value: function appendComponentNode(node) {
      this.$node.append(node);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return ScreenView;
}(_view2.default);

ScreenView.extendStyleNames(_screen2.default);

exports.default = ScreenView;
//# sourceMappingURL=screen.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/screen/screen.view.js
// module id = 1704
// module chunks = 1 2 3